export default {
  tabs: {
    gift_cards: 'Gavekort',
    settings: 'Indstillinger',
  },
  gift_cards: {
    title: 'Gavekort',
    subtitle: 'Administrer alle gavekort til din restaurant',
    buttons: {
      create: 'Opret gavekort',
      redeem: 'Indløs gavekort',
      check_balance: 'Tjek saldo',
    },
    search: {
      placeholder: 'Indtast søgetekst',
    },
    columns: {
      code: 'Kode',
      status: 'Status',
      balance: 'Saldo',
      value: 'Værdi',
      email: 'Køber',
      source: 'Kilde',
      created_at: 'Oprettet',
    },
    statuses: {
      active: 'Aktiv',
      partially_redeemed: 'Delvist indløst',
      redeemed: 'Indløst',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Indstillinger for gavekort',
      subtitle: 'Konfigurer gavekortindstillinger for din restaurant',
      availability: {
        title: 'Aktivér gavekort',
        subtitle: 'Lad kunder købe og indløse gavekort',
        buttons: {
          enable: 'Aktivér',
          disable: 'Deaktivér',
        },
      },
    },
    redemption_options: {
      title: 'Indløsningsmuligheder',
      subtitle: 'Vælg, hvor kunder kan indløse gavekort',
      redemption_mode: {
        title: 'Indløsningsform',
        subtitle: 'Dette påvirker teksten på din landingsside for gavekort',
        buttons: {
          online: 'Kun online',
          online_and_store: 'Online & i butikken',
        },
      },
    },
  },
  summary: {
    total_value: 'Samlet værdi',
    total_active: 'I alt aktive',
    redeemed_this_month: 'Indløst denne måned',
  },
};
